import type { CurrencyInfo, Order } from '@src/domains/orders';
import { DirectLinkType, type DirectLink } from '@src/domains/direct-links/types/directLink';

export const getDirectLinkTotalCurrencyInfo = (directLink: DirectLink, order: Order | null | undefined): CurrencyInfo =>
  (directLink.type === DirectLinkType.Order ? order?.finalAmountCurrencyInfo : undefined) ??
  directLink.totalAmountCurrencyInfo;
